<script setup>
import { ref, reactive, onMounted } from "vue";
import { apiQuery } from "@/api/j24api";
import VSelectSearch from "@/components/VSelectSearch.vue";
import FileStructure from "./FileStructure.vue";
import ElevateESFEvent from "./ElevateESFEvent.vue";

const wholePageLoading = ref(false);
const licences = reactive([]);
const licenceName = ref("Jigsaw24 Elevate Demo");

onMounted(async () => {
  wholePageLoading.value = true;
  const result = await apiQuery("ELA", "elevatereports", {
    apiAction: "GetLicences",
  });
  licences.length = 0;
  result.forEach((licence) => {
    licences.push(licence);
  });
  //licenceName.value = licences[0].name;
  wholePageLoading.value = false;

  // Remove before release
  getEvents();
});

const loadingEvents = ref(false);
const events = reactive([]);

async function getEvents() {
  loadingEvents.value = true;
  events.length = 0;
  let result = await apiQuery("ELA", "elevatereports", {
    apiAction: "ESFReport",
    esfReportAction: "GetEvents",
    elevateLicence: licenceName.value,
  });
  console.log(result);
  if (result.length) {
    result.forEach((event) => {
      events.push(event);
    });
  }
  loadingEvents.value = false;
}

const eventsHeaders = [
  { text: "Serial Number", value: "serialNumber", sortable: true },
  { text: "Username", value: "username", sortable: true },
  { text: "Timestamp", value: "timestamp", sortable: true },
  // { text: "Actions", value: "actions", sortable: false },
];

const eventsHeadersV2 = [
  { title: "Serial Number", value: "serialNumber", sortable: true },
  {
    title: "Timestamp",
    value: (item) => `${item}`,
    sortable: true,
  },
  { title: "Actions", value: "actions", sortable: false },
];

const selectedEvent = ref(false);

function formatDate(date) {
  // if epoch date is in milliseconds, convert to seconds
  if (date.toString().length > 10) {
    date = Math.floor(date / 1000);
  }
  return new Date(date * 1000).toLocaleString();
}

const logEvents = reactive([]);
async function getEvent() {
  wholePageLoading.value = true;
  console.log(selectedEvent.value);
  let result = await apiQuery("ELA", "elevatereports", {
    apiAction: "ESFReport",
    esfReportAction: "GetEvent",
    elevateLicence: licenceName.value,
    customReference: selectedEvent.value.customReference,
  });
  if (result.length > 0) {
    logEvents.length = 0;
    logEvents.push(...result);
  }
  wholePageLoading.value = false;
}

const selectEvent = (event) => {
  selectedEvent.value = event;
  //getEvent();
};

const logEventszz = [
  {
    _id: "65a16ad0492ce59b9d1dc163",
    serialNumber: "HFXP2L44MD",
    licenseName: "Jigsaw24 Elevate Demo",
    processTree: [],
    signingid: "com.apple.mobileassetd",
    arguments: [],
    username: "root",
    teamId: "",
    customReference: "76610C8B-F53E-491B-BAA9-E25485084BBB",
    target:
      "/com.apple.mobileassetd.Query.Attempt_AA42C6B5-3FE9-4C05-B802-4882D03D3ABE.MADAnalytics",
    isplatform: true,
    pid: 92226,
    ppid: 1,
    timestamp: 1705077394705,
    processpath: "/usr/libexec/mobileassetd",
    saved: false,
    action: "",
    eventtype: "File:Write",
    source: "",
    __v: 0,
  },
];
</script>

<template>
  <template v-if="wholePageLoading">
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-center pt-11">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </template>
  <template v-else>
    <template v-if="!selectedEvent">
      <v-row>
        <v-col>
          <VSelectSearch
            label="Choose Elevate License"
            :items="licences"
            item-title="name"
            item-value="name"
            v-model="licenceName"
            variant="underlined"
            hide-details="auto"
            density="compact"
            @update:modelValue="getEvents()"
            activateSearch
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <EasyDataTable
            :headers="eventsHeaders"
            :items="events"
            :loading="loadingEvents"
            theme-color="#e7541e"
            sort-by="timestamp"
            sort-type="desc"
            @click-row="selectEvent"
          >
            <template #item-timestamp="item">
              {{ formatDate(item.timestamp) }}
            </template>
            <template #item-actions="item">
              <v-icon @click="selectedEvent = item">mdi-magnify</v-icon>
            </template>
          </EasyDataTable>
        </v-col>
      </v-row>
    </template>
    <template v-if="selectedEvent">
      <ElevateESFEvent
        :licenceName="licenceName"
        :eventReference="selectedEvent.customReference"
        :username="selectedEvent.username"
        :serialNumber="selectedEvent.serialNumber"
        @back="selectedEvent = false"
      />
      <!-- <v-row v-if="logEvents.length">
        <v-col>
          <h1>Files Modified</h1>
          <FileStructure :events="logEvents" />
        </v-col>
      </v-row> -->
    </template>
  </template>
</template>
